// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3924":"ce4dc036","6399":"aa954d74"}[chunkId] + ".chunk.css";
};